module.exports = __webpack_public_path__ + "media/app/apple-badge-pt-a8c59326.svg";